<i18n>
{
	"en": {
		"dateFrom": "Choose date from",
		"dateTo": "Choose date until",
		"departureDate": "Date of departure",
		"places": "Places",
		"choosePlace": "Choose place",
		"failedToFetch": "Failed to search for trips"
	},
	"no": {
		"dateFrom": "Velg dato fra",
		"dateTo": "Velg dato til",
		"departureDate": "Avgangsdato",
		"places": "Steder",
		"choosePlace": "Velg sted",
		"failedToFetch": "Kunne ikke søke etter turer"
	}
}
</i18n>
<template>
	<div class="map-trip-search-form">
		<div class="map-trip-search-form-departure">
			<t-text bold="true">{{$t('departureDate')}}</t-text>
			<t-date-picker
				:placeholder="$t('dateFrom')"
				:value="formatDate(searchFilter.etd.from)"
				:dateFormat="displayDateFormat"
				width="100%"
				relative
				@input="setFrom"
				@enter="searchTrips"
			/>
			<t-date-picker
				:placeholder="$t('dateTo')"
				:value="formatDate(searchFilter.etd.to)"
				:dateFormat="displayDateFormat"
				width="100%"
				relative
				@input="setTo"
				@enter="searchTrips"
			/>
		</div>
	</div>
</template>

<script>
import TText from './TText.vue';
import { mapDynamicState, mapDynamicActions } from '@/core/mapDynamic';
import {
	displayDateFormat, displayDateFormatter, eventBus
} from '@/core';

export default {
	name: 'MapTripSearchForm',
	components: { TText },
	inject: ['namespace'],
	computed: {
		...mapDynamicState('computedStoreNamespace',[
			'searchFilter',
			'tripsLoading',
		]),
		computedStoreNamespace() {
			return `loadPlanning/${this.namespace.id}/tripSearch`;
		},
		displayDateFormat() {
			return displayDateFormat;
		},
	},
	created() {
		eventBus.$on('refreshTripList', this.searchTrips);
	},
	beforeDestroy() {
		eventBus.$off('refreshTripList');
	},
	methods: {
		...mapDynamicActions('computedStoreNamespace',[
			'fetchTrips',
			'setDateFrom',
			'setDateTo',
		]),
		setFrom(date) {
			if (this.formatDate(this.searchFilter.etd.from) === date) return;
			this.setDateFrom(date);
			this.searchTrips();
		},
		setTo(date) {
			if (this.formatDate(this.searchFilter.etd.to) === date) return;
			this.setDateTo(date);
			this.searchTrips();
		},
		async searchTrips() {
			if (this.tripsLoading) {
				return;
			} else {
				try {
					this.fetchTrips();
				} catch (e) {
					this.$notify({
						type: 'error',
						title: this.$t('failedToFetch')
					});
				}
			}
		},
		formatDate(date) {
			return displayDateFormatter(date);
		}
	}
};
</script>

<style scoped>
.map-trip-search-form {
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	padding-left: 10px;
	padding-right: 10px;
	position: relative;
}

.map-trip-search-form > *:first-child {
	padding-right: 10px;
}

.map-trip-search-form::after {
	content: '';
	width: 1px;
	height: 110px;
	background: #e4e7eb;
	position: absolute;
	top: 0;
	right: 0;
}


.map-trip-search-form-departure, .map-trip-search-form-places {
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
}

.map-trip-search-form-departure > *, .map-trip-search-form-places > * {
	padding-bottom: 10px;
}
</style>
